// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"6b334592","213":"0f1c1d57","531":"c2f9de85","684":"90f662ee","787":"dbe6f60f"}[chunkId] + ".chunk.js";
};